
// component
import SvgColor from '../../../components/svg-color';


// rms

import icDashboard from '../../../assets/rms/icon/dashboard.svg';
import icUser from '../../../assets/rms/icon/user.svg';
import icTable from '../../../assets/rms/icon/table.svg';


const icon = (name) => <SvgColor src={name} sx={{ width: 1, height: 1 }} />;

// super admin panel

export const superAdminNavConfig = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: icon(icDashboard),
  },
  {
    title: 'Admin',
    path: '/admin',
    icon: icon(icUser),
  },
  {
    title: 'Restaurant',
    path: '/restaurant',
    icon: icon(icTable),
  },
  {
    title: 'Restaurant User',
    path: '/user',
    icon: icon(icUser),
  },

];


